//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head () {
    return {
      meta: [
        ...this.getDescription('Get inspired by the SunGod Instagram shop.')
      ]
    }
  }
}
